<template>
  <div>
    <v-select :filterable="false" @search="fetchOptions" v-model="selected" :options="options"
      :dir="$vs.rtl ? 'rtl' : 'ltr'" /><br>
  </div>
</template>

<script>
import vSelect from 'vue-select'
import { axiosMixin } from "@/mixin/axiosMixin.js";
import { mapGetters } from "vuex";
export default {
  mixins: [axiosMixin],
  data() {
    return {
      options: [
      ],
      selected: {},
    }
  },
  watch: {
    selected(value) {
      this.$emit('input', value);

      this.$store.state.main.inventoryData = {};
    },
    'getGr.compId': function (newVal, oldVal) {
      this.getmasterCode();
    },
    'getGr.stock': function (newVal, oldVal) {
      this.getmasterCode();
    }

  },
  components: {
    'v-select': vSelect,
  },
  computed: {
    ...mapGetters({
      getGr: "main/getGr",
    })
  },
  mounted() {
    this.selected = this.getGr.masterStockCode;
    this.getmasterCode();
  },
  methods: {
    getmasterCode() {
      var params = "page1&per_page=10";
      var sort = "&sort_by=id&sort_direction=asc";

      this.aronPost("getAllMasterCode", { masterCode: "all" }, params, sort)
        .then(response => {
          console.log("date", response.data);
          if (response.status == 200) {
            this.options = response.data.masterStockCode;
          }

        })
        .catch(error => {
        });
    },
    fetchOptions(search, loading) {
      loading(true)
      // fetch data from server
      var params = "page1&per_page=10";
      var sort = "&sort_by=id&sort_direction=asc";
      this.aronPost("getAllMasterCode", { masterCode: search }, params, sort)
        .then(response => {
          console.log("date", response.data);
          if (response.status == 200) {
            this.options = response.data.masterStockCode;
          }

          loading(false)
        })
        .catch(error => {
          // this.decodeErrorFromAxios(error);
          loading(false)
        });
    }
  }
}
</script>
